﻿﻿﻿<!--<elevator-menu (outputDownload)="downloadElevatorFiltered()" (onReload)="onReload()"></elevator-menu>-->
<elevator-filter (outputFilter)="getFilteredElevatorsByTenant()"></elevator-filter>
<elevator-list [list]="list" [showLocalFilter]="showLocalFilter"></elevator-list>